<template>
  <b-button-group>
    <McButton
      text="Simpan sebagai Draf"
      class="__button-group"
      icon="icon-outline_save"
      :disabled="isLoading"
      @click="handleClickItem('DRAFT')"
    />

    <div class="mc-border"></div>

    <b-dropdown class="mc-buttons-dropdown" variant="primary" :disabled="isLoading">
      <template #button-content>
        <i class="mc-icon icon-outline_chevron-down" style="font-size: 18px" />
      </template>

      <b-dropdown-item
        v-for="status in statuses"
        :key="status.key"
        :disabled="isLoading"
        @click="() => handleClickItem(status.key)"
      >
        <div class="d-flex gap-2">
          <span>Simpan sebagai</span>
          <McBadge type="button" size="sm" :text="status.label" :variant="status.variant" />
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </b-button-group>
</template>

<script>
import McButton from '@/components/McButton'
import McBadge from '@/components/McBadge'

export default {
  components: {
    McButton,
    McBadge,
  },
  props: {
    statuses: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  methods: {
    handleClickItem(status) {
      this.$emit('click', status)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.__button-group) {
  .mc-button {
    border-radius: 4px 0 0 4px;
    height: 100%;
  }
}

:deep(.mc-buttons-dropdown) {
  .icon-provider {
    width: 20px;
  }

  .mc-icon:before {
    color: $white;
  }
}

:deep(.mc-border) {
  width: 2px;
  background: $white;
}

:deep(.red-text) {
  a {
    color: $red;
  }
}
</style>
